const defaultCoverUrl =
  'https://burninghut.ru/wp-content/uploads/2023/10/cropped-new_favicon_bh-1.png';
const defaultDescription = 'Горящая изба - Женское издание про всё';

export default [
  { charset: 'utf-8' },
  { name: 'viewport', content: 'width=device-width, initial-scale=1' },
  { key: 'description', name: 'description', content: defaultDescription },

  // отключает изменение html разметки на ios
  {
    name: 'format-detection',
    content: 'telephone=no,date=no,address=no,email=no,url=no',
  },

  // START FAVICON
  {
    key: 'msapplication-TileColor',
    name: 'msapplication-TileColor',
    content: '#da532c',
  },
  { key: 'theme-color', name: 'theme-color', content: '#ffffff' },
  // END FAVICON

  // BEGIN OG
  { key: 'og:image', property: 'og:image', content: defaultCoverUrl },
  {
    key: 'og:publisher',
    property: 'og:publisher',
    content: '//www.facebook.com/BurningHutRu/',
  },
  { key: 'og:site_name', property: 'og:site_name', content: 'Горящая Изба' },
  { key: 'og:type', property: 'og:type', content: 'website' },
  { key: 'og:url', property: 'og:url', content: 'https://burninghut.ru/' },
  { key: 'og:title', property: 'og:title', content: defaultDescription },
  {
    key: 'og:description',
    property: 'og:description',
    content: defaultDescription,
  },
  // END OG
  {
    key: 'twitter:title',
    property: 'twitter:title',
    content: defaultDescription,
  },
  {
    key: 'twitter:description',
    property: 'twitter:description',
    content: defaultDescription,
  },
  {
    key: 'twitter:card',
    property: 'twitter:card',
    content: 'summary_large_image',
  },
  { key: 'twitter:image', property: 'twitter:image', content: defaultCoverUrl },
  { key: 'twitter:site', property: 'twitter:site', content: '@BurningHutRu' },
  {
    key: 'twitter:creator',
    property: 'twitter:creator',
    content: '@BurningHutRu',
  },
  { key: 'telegram:channel', name: 'telegram:channel', content: '@BurningHut' },
  { key: 'view-transition', name: 'view-transition', content: 'same-origin' },
];
